<template>
  <div class="transition">
    <BasicText
      size="h5"
      class="titre-transition"
    >
      Attention
    </BasicText>
    <div v-if="props.in.context === 'adherent'" class="transition-items flex flex-column flex-gap-8">
      <section style="max-width: 800px">
        <BasicText size="body-xl">
          Confirmer que votre entreprise est légitime pour déposer une demande chez AKTO (Établissement avec un IDCC
          AKTO ou Mayotte) ou pour accéder à d'anciens dossiers.
          <br />
          <br />
          Lien :
          <BasicLink
            label="France Compétences"
            @link-click="redirectExterne('https://quel-est-mon-opco.francecompetences.fr')"
          />
        </BasicText>
      </section>

      <section>
        <BasicCheckbox
          label="Je confirme que mon entreprise est bien légitime à déposer une demande chez AKTO"
          v-model="estConfirmé"
        />
      </section>
    </div>
    <div v-else class="transition-items flex flex-column flex-gap-8">
      <section>
        <BasicText size="body-xl">
          Confirmer que votre entreprise est légitime pour déposer une demande chez AKTO en tant que prestataire de formation.
        </BasicText>
      </section>

      <section>
        <BasicCheckbox
          label="Je confirme que mon entreprise est bien légitime à déposer une demande chez AKTO dans le cadre de son activité commerciale de formation"
          v-model="estConfirmé"
        />
      </section>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import type { CarteEvents, CarteProps } from '@/features/interface/machine-etats/types'
  import type { DemandeRattachementResult } from '../types'
  import { redirectExterne } from '@/features/shared/tools/url'

  type In = Pick<DemandeRattachementResult, 'context'>
  type Out = Pick<DemandeRattachementResult, 'demandeRattachementConfirmée'>

  const props = defineProps<CarteProps<In, Out>>()
  const emits = defineEmits<CarteEvents<Out>>()

  const estConfirmé = computed({
    get: () => props.out?.demandeRattachementConfirmée,
    set: (value) => emits('outChanged', value === true, { demandeRattachementConfirmée: value }),
  })
</script>

<style lang="less" scoped>
  .transition-items {
    max-width: 550px;
  }
</style>
